export default ".dialog-text {\n  max-width: 98% !important;\n  width: 95% !important;\n}"